import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslationService } from '@lciapps/lci-core';
import { FeatureService } from '../feature.service';
import { ServiceTypeEnum } from '../features/activities/shared/models/service-type.enum';

@Component({
  selector: 'app-footer',
  template: `
    <div class="container">
      <div class="row">
        <ul class="footerList col">
          <li class="title" translate="lblServiceActivities">
            <strong>Service Activities</strong>
          </li>
          <li *ngFor="let link of exploreLinks">
            <a
              href=""
              [routerLink]="link.route"
              [translate]="link.translationKey"
              >{{ link.label }}</a
            >
          </li>
        </ul>
        <ul class="footerList col">
          <li class="title" translate="lblResources">
            <strong>Resources</strong>
          </li>
          <li *ngFor="let link of resourcesLinks">
            <a
              *ngIf="link.route"
              [routerLink]="link.route"
              target="_blank"
              [translate]="link.translationKey"
              >{{ link.label }}</a
            >
            <a
              *ngIf="link.click"
              href
              (click)="link.click($event)"
              [translate]="link.translationKey"
              >{{ link.label }}</a
            >
            <a
              *ngIf="link.direct"
              (click)="reloadZendesk(link.reloadZendesk)"
              [href]="link.direct"
              target="_blank"
              [translate]="link.translationKey"
              >{{ link.label }}</a
            >
          </li>
        </ul>
        <div class="footerBranding col">
          <div class="title">Lions Clubs International</div>
          <div class="address">
            300 W. 22nd Street <br />
            Oak Brook, IL 60523-8842 USA
          </div>
          <div class="telephone">+1 (630) 468-6900</div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .container {
        background-color: #153054;
        padding: 24px;
      }
      .container ul {
        list-style: none;
      }
      .footerList li.title {
        color: #f0c710;
        margin-bottom: 20px;
        font-weight: bold;
      }
      .footerList li {
        margin-bottom: 10px;
        color: white;
      }
      .footerList li a {
        color: white;
        font-weight: lighter;
      }
      .footerBranding {
        color: white;
      }
      .footerBranding .title {
        font-weight: 900;
        font-size: 1.1em;
      }
      .footerBranding .address {
        margin: 20px 0;
      }
    `
  ]
})
export class FooterComponent implements OnInit {
  public cachedZendeskUrl = '';
  public exploreLinks = [
    {
      label: 'Create',
      route: ['/activities/create', { type: ServiceTypeEnum.Future }, 'new'],
      translationKey: 'btnCreate'
    },
    {
      label: 'My Activities',
      route: ['/activities/discover'],
      translationKey: 'lblMyactivities'
    },
    {
      label: 'Metrics Dashboard',
      route: ['/activities/explore'],
      translationKey: 'lblDashboard'
    }
  ];
  public featureService: FeatureService;
  public resourcesLinks = [
    {
      label: 'Contact Us',
      direct: '',
      reloadZendesk: true,
      /* click: ($event) => {
          if ($event) {
              $event.stopPropagation();
              $event.preventDefault();
          }
          this.featureService.getZendeskUrl().subscribe(url => {
               // window.location.href = url;
              window.open(url,'_blank');
          });
        }, */
      translationKey: 'btnContactUs'
    },
    {
      label: 'Privacy Policy',
      direct: 'https://www.lionsclubs.org/EN/privacy-policy.php',
      translationKey: 'menuPrivacyPolicy'
    },
    {
      label: 'Terms of Use',
      direct: 'https://www.lionsclubs.org/EN/terms-of-use.php',
      translationKey: 'menuTermsandConditions'
    }
  ];
  constructor(
    private fs: FeatureService,
    private translationService: TranslationService,
    private router: Router
  ) {
    this.featureService = fs;
  }

  ngOnInit() {
    this.featureService.zenDeskUrl.subscribe(url => {
      this.resourcesLinks[0].direct = url;
    });
    /*
            this.translationService.getTranslationValue('btnHome').subscribe(val => {
                this.links[0].label = val;
            });
            this.translationService.getTranslationValue('lblDiscover').subscribe(val => {
                this.links[1].label = val;
            });
            this.translationService.getTranslationValue('btnCreate').subscribe(val => {
                this.links[2].label = val;
            });
            this.translationService.getTranslationValue('btnExplore').subscribe(val => {
                this.links[3].label = val;
            });
            */
  }

  reloadZendesk(val) {
    if (val) {
      this.featureService.getZendeskUrl().subscribe();
    }
  }
}
